import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/styles/scss/main.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./pages/NotFound";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import "react-slideshow-image/dist/styles.css";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import About from "./pages/About";
import Shipping from "./pages/Shipping";
import Returns from "./pages/Returns";
import Privacy from "./pages/Privacy";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Terms from "./pages/Terms";
import Account from "./pages/Account";
import axios from "axios";
import { useContext } from "react";
import { Context } from "./context/MainContext";
import { userLogOut } from "./context/Action";
import VerifyMail from "./pages/VerifyMail";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import Services from "./pages/Services";
import Training from "./pages/Training";
import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import CheckoutEnroll from "./pages/CheckoutEnroll";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import "react-loading-skeleton/dist/skeleton.css";

function App() {
  const { user, dispatch } = useContext(Context);

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        if (user && user?.id) {
          localStorage.removeItem("sokoUser");
          dispatch(userLogOut());
        }
      }
      return Promise.reject(error);
    },
  );

  return (
    <div className="App">
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route path="*" element={<NotFound />} />
            <Route index element={<Home />} />
            <Route path="products" element={<Shop />} />
            <Route path="shop/:name" element={<Shop />} />
            <Route path="products/:cat" element={<Shop />} />
            <Route path="product/:id" element={<Product />} />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="training" element={<Training />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<NewsDetails />} />
            {/* <Route path="shipping" element={<Shipping />} />
            <Route path="returns" element={<Returns />} /> */}
            <Route path="terms&conditions" element={<TermsAndConditions />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="login" element={<Signin />} />
            <Route path="signup" element={<Signup />} />
            <Route path="verify-mail/:token" element={<VerifyMail />} />
            <Route path="forgot-password" element={<ForgetPassword />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="contact" element={<Contact />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="checkout-enroll" element={<CheckoutEnroll />} />
            <Route path="account" element={<Account />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
